<div class="page-title-area">
    <img src="assets/images/apple-business.png" alt="Page Background" class="page-bg">
    <div class="container">
       <!--  <div class="page-title-content">
            <h2>Apple Business Manager </h2>
            <p>Apple Business Manager is a web-based portal that helps organisations seamlessly deploy and manage Apple devices.</p>      
        </div> -->
    </div>

    <!-- <div>
        <img src="assets/images/case-studies.png">
    </div> -->
   <!--  <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div> -->
</div>

<section class="home-service-area pb-70">
    <div class="container">
        <div class="section-title">
            <!-- <p>"Superior Digital: Expert Apple Device Support at Your Convenience"Experience certified expertise, genuine parts, and comprehensive services with tailored solutions for all your Apple device needs “</p> -->
            <h2 style="padding-top: 60px;">Apple Business Manager </h2>
            <p>It enables automatic device enrolment in MDM, streamlined app and content distribution, and secure access management with Managed Apple Account.</p>
            <p>This simplifies IT workflows, enhances security, and improves efficiency in deploying Apple devices at scale.</p>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-4 col-sm-6">
                <div class="single-service">
                    <!-- <div class="service-img">
                        <img src="assets/images/service/s1.png" alt="service" />
                    </div> -->

                    <div class="service-content">
                        <h3>Seamless Device Deployment</h3>
                        <p>Automates device enrolment into MDM, eliminating manual setup and ensuring a zero-touch deployment experience.</p>
                        <!-- <a routerLink="/solutions-details" class="line-bnt">Read More</a> -->
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="single-service">
                    <!-- <div class="service-img">
                        <img src="assets/images/service/s2.png" alt="service" />
                    </div> -->

                    <div class="service-content">
                        <h3>Effortless App & Content Distribution</h3>
                        <p>Enables bulk purchasing and remote assignment of apps, books, and custom apps through Managed Apple Account.</p>
                        <!-- <a routerLink="/solutions-details" class="line-bnt">Read More</a> -->
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="single-service">
                    <!-- <div class="service-img">
                        <img src="assets/images/service/s3.png" alt="service" />
                    </div> -->

                    <div class="service-content">
                        <h3>Enhanced Security & Compliance</h3>
                        <p>Ensures secure device management with role-based access, automatic supervision, and integration with identity providers.</p>
                        <!-- <a routerLink="/solutions-details" class="line-bnt">Read More</a> -->
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="single-service">
                    <!-- <div class="service-img">
                        <img src="assets/images/service/s4.png" alt="service" />
                    </div> -->

                    <div class="service-content">
                        <h3>Centralised Management</h3>
                        <p>Provides a single dashboard to manage Apple devices, users, and content, reducing IT workload and increasing efficiency.</p>
                        <!-- <a routerLink="/solutions-details" class="line-bnt">Read More</a> -->
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-6">
                <div class="single-service">
                    <!-- <div class="service-img">
                        <img src="assets/images/service/s5.png" alt="service" />
                    </div> -->

                    <div class="service-content">
                        <h3>Scalability & Flexibility</h3>
                        <p>Supports organisations of all sizes, from SMBs to enterprises, by streamlining device lifecycle management and improving end-user experience.</p>
                        <!-- <a routerLink="/solutions-details" class="line-bnt">Read More</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>